export const TIMEZONE = 'Canada/Eastern'
export const TIMEZONE_FR_CODE = 'fr-ca'
export const TIMEZONE_EN_CODE = 'en-ca'

export function normalizeDateToUnix(date: string) {
  if (date) {
    let d: Date
    if (!isNaN(+date)) {
      //UNIX timestamp from Supabase
      d = new Date(+date * 1000)
    } else if (!isNaN(Date.parse(date))) {
      //ISO string from Supabase
      d = new Date(date)
    } else {
      return null
    }
    return d
  }
}
export const formatDate = (date: string, options: any, lang = TIMEZONE_FR_CODE) => {
  const d = normalizeDateToUnix(date)
  if (d) {
    options.timeZone = TIMEZONE
    return new Intl.DateTimeFormat(lang, options)
      .format(d)
      .replace(' h ', ':')
      .replace(' p.m.', 'pm')
      .replace(' a.m.', 'am')
  } else {
    return null
  }
}

export const isRenderEndDate = (startDate?: string, endDate?: string) => {
  if (startDate && endDate) {
    const date1 = formatDate(startDate, { day: 'numeric', month: 'short', year: 'numeric' })
    const date2 = formatDate(endDate, { day: 'numeric', month: 'short', year: 'numeric' })

    if (date1 === date2) {
      return false
    } else {
      return true
    }
  } else {
    return false
  }
}

export const formatEventDateTime = (
  lang: string,
  config: any,
  startDate?: string,
  endDate?: string
) => {
  const langCode = lang === 'en' ? TIMEZONE_EN_CODE : TIMEZONE_FR_CODE
  if (startDate) {
    const startTime = config.includeStartTime
      ? ` - ${formatStartTime(lang, startDate, endDate)}`
      : ''
    if (startDate && endDate) {
      if (isRenderEndDate(startDate, endDate)) {
        return `${formatDate(startDate, { day: 'numeric', month: 'short', year: 'numeric' }, langCode)} - ${formatDate(endDate, { day: 'numeric', month: 'short', year: 'numeric' }, langCode)}`
      } else {
        return `${formatDate(startDate, { day: 'numeric', month: 'short', year: 'numeric' }, langCode) + startTime}`
      }
    } else if (startDate && !endDate) {
      return `${formatDate(startDate, { day: 'numeric', month: 'short', year: 'numeric' }, langCode) + startTime}`
    } else {
      return null
    }
  } else {
    return null
  }
}

export const formatStartTime = (lang: string, startDate?: string, endDate?: string) => {
  const langCode = lang === 'en' ? TIMEZONE_EN_CODE : TIMEZONE_FR_CODE
  if (isRenderEndDate(startDate, endDate)) {
    return ''
  }
  if (startDate) {
    return formatDate(
      startDate,
      { hour: 'numeric', minute: 'numeric', timeZoneName: 'short' },
      langCode
    )
  } else {
    return ''
  }
}
